module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Anna Katharine Green\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Anna Katharine Green (1846–1935) was an American writer and one of the first authors of detective fiction in the United States. Her book "), _c('I', [_vm._v("The Leavenworth Case")]), _vm._v(", published in 1878, became a wildly successful bestseller. Green went on to write dozens of mysteries and detective novels. She died in Buffalo, New York. ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ODagey/tc-custom/9781504074902.jpg?1701632881583",
      "alt": "This image is the cover for the book Millionaire Baby"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Millionaire Baby\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("The search for a missing child uncovers a wealthy family’s darkest secrets in this 1905 mystery by the author of "), _c('i', [_vm._v("The Circular Study")]), _vm._v(".")])]), _c('p', [_vm._v("On the morning of August 18, six-year-old heiress Gwendolen Ocumpaugh went missing from her family’s Hudson Valley estate. Now her parents are offering a fortune to anyone who can locate her, dead or alive. The distressing announcement causes a stir across New York, but it is a welcome opportunity for struggling private detective Mr. Trevitt. He knows the family. He knows the girl. And he could certainly use the money.")]), _vm._v(" When one of Gwendolen’s shoes is found in the bushes and the. Other in the river, it seems to confirm the worst. But Mr. Trevitt smells a plot. As he continues his investigation, the shocking truth of Gwendolen’s whereabouts reveals buried secrets and devious deceptions.\n    "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0